/**
 * Starter min/max/unit for Floor Sheet bevel limit bands (inches).
 * Tune in one place; persisted on `floorsheet.welds[].limitSettings`.
 */
export const FLOOR_SHEET_DEFAULT_LIMITS = {
  'Wall Thickness': { min: '0.25', max: '2', unit: 'in' as const },
  'Shelf Height': { min: '0', max: '1', unit: 'in' as const },
  Offset: { min: '0', max: '0.5', unit: 'in' as const },
  'Land Thickness': { min: '0', max: '0.25', unit: 'in' as const }
} as const
